import { AppError, extractMessage } from '@/helpers'

export class NativeDelegateError extends AppError {
  constructor(options: { userMessage?: string; originalError?: unknown }) {
    super({
      title: 'Native delegation failed',
      userMessage: options.userMessage,
      originalError: options.originalError,
      context: 'native-delegate',
    })
    this.name = 'NativeDelegateError'
  }

  static fromUnknown(error: unknown): NativeDelegateError {
    const raw = extractMessage(error)
    const lower = raw.toLowerCase()
    if (lower.includes('insufficient funds')) {
      return new NativeDelegateError({
        userMessage: 'Insufficient funds to delegate',
        originalError: error,
      })
    }
    if (lower.includes('validator does not exist')) {
      return new NativeDelegateError({
        userMessage: 'Selected validator does not exist',
        originalError: error,
      })
    }
    return new NativeDelegateError({
      userMessage: raw || undefined,
      originalError: error,
    })
  }
}

export class NativeUndelegateError extends AppError {
  constructor(options: { userMessage?: string; originalError?: unknown }) {
    super({
      title: 'Native undelegation failed',
      userMessage: options.userMessage,
      originalError: options.originalError,
      context: 'native-undelegate',
    })
    this.name = 'NativeUndelegateError'
  }

  static fromUnknown(error: unknown): NativeUndelegateError {
    const raw = extractMessage(error)
    const lower = raw.toLowerCase()
    if (lower.includes('no delegation')) {
      return new NativeUndelegateError({
        userMessage: 'No active delegation found',
        originalError: error,
      })
    }
    if (lower.includes('too many unbonding delegation entries')) {
      return new NativeUndelegateError({
        userMessage:
          'Too many undelegations in progress. Wait for them to finish.',
        originalError: error,
      })
    }
    if (lower.includes('insufficient funds')) {
      return new NativeUndelegateError({
        userMessage: 'Insufficient funds to cover fees',
        originalError: error,
      })
    }
    return new NativeUndelegateError({
      userMessage: raw || undefined,
      originalError: error,
    })
  }
}

export class NativeRedelegateError extends AppError {
  constructor(options: { userMessage?: string; originalError?: unknown }) {
    super({
      title: 'Native redelegation failed',
      userMessage: options.userMessage,
      originalError: options.originalError,
      context: 'native-redelegate',
    })
    this.name = 'NativeRedelegateError'
  }

  static fromUnknown(error: unknown): NativeRedelegateError {
    const raw = extractMessage(error)
    const lower = raw.toLowerCase()
    if (lower.includes('no delegation')) {
      return new NativeRedelegateError({
        userMessage: 'No active delegation found',
        originalError: error,
      })
    }
    if (
      lower.includes('redelegation to this validator already in progress') ||
      lower.includes('redelegation already in progress')
    ) {
      return new NativeRedelegateError({
        userMessage:
          'Redelegation to this validator is already in progress. Wait for it to complete before redelegating again.',
        originalError: error,
      })
    }
    if (lower.includes('too many redelegation entries')) {
      return new NativeRedelegateError({
        userMessage:
          'Too many redelegations in progress. Wait for them to finish.',
        originalError: error,
      })
    }
    if (lower.includes('validator does not exist')) {
      return new NativeRedelegateError({
        userMessage: 'Selected validator does not exist',
        originalError: error,
      })
    }
    if (lower.includes('insufficient funds')) {
      return new NativeRedelegateError({
        userMessage: 'Insufficient funds to cover fees',
        originalError: error,
      })
    }
    return new NativeRedelegateError({
      userMessage: raw || undefined,
      originalError: error,
    })
  }
}
